export function getApiBaseURL() {
  const baseURL = window.__APP_CONFIG__.API_BASE_URL;

  return baseURL;
}

export function getApiURL(path) {
  const baseURL = window.__APP_CONFIG__.API_BASE_URL;
  return baseURL + path;
}
